export default "__VITE_ASSET__c9f9b0ef__"